import {
  UlmTextField,
  UlmTextFieldProps,
} from "@components/ulm/ulm-text-field";
import { REGION_SERVER_IDENTIFIER } from "@constants/server-constants";
import { runtimeConfig } from "@src/runtime-config";

interface Props {
  /** The email address to display */
  email: string;

  /** Optional style props to pass to the component */
  sx?: UlmTextFieldProps["sx"];
}

/** Renders the email address and selected region during signup flows */
export function SignupEmailIndicator({ email, sx }: Props): JSX.Element {
  return (
    <UlmTextField
      value={email}
      placeholder="email"
      isDisabled
      serverIdentifier={REGION_SERVER_IDENTIFIER[runtimeConfig.appRegion]}
      sx={sx}
    />
  );
}
